class UnsupportedError extends Error{
	constructor(message = ""){
		super(message);
	}
}

export default UnsupportedError